import React from 'react';
import CapPopover from '../CapPopover';
import Divider from './Divider';
import DisabledHoverPopover from './DisabledHoverPopover';
import CollapsibleItemsWrapper from './CollapsibleItemsWrapper';
import SubModuleSingleItem from './SubModuleSingleItem';
import QuickLinkSingleItem from './QuickLinkSingleItem';
import './_index.scss';
import { validateDisabledConfig, FormattedMessageWrapper } from './utils';
import CapHeading from '../CapHeading';
import CapRow from '../CapRow';

const L2Module = ({
  subModule,
  currentState,
  dispatchAction,
  handleRedirectionAndModuleSelection,
  l1_itemHovered,
  pushDataToGTM,
  redirectToLink,
}) => {
  const {
    type,
    displayLabel,
    name,
    _id,
    nextSectionDisplayLabel,
    nextSectionName,
    disabled = false,
    disabledConfig = {},
  } = subModule;
  const itemSelected = _id ? _id === currentState?.selectedL2Module?._id : name === currentState?.selectedL2Module?.name;
  const itemHovered = name === currentState.hoveredL2Module;
  return (
    <>
      {type === 'subModule' &&
        (disabled && validateDisabledConfig(disabledConfig) ? (
          <CapPopover
            placement="right"
            content={
              <DisabledHoverPopover
                {...disabledConfig}
                title={
                  <FormattedMessageWrapper id={displayLabel} message={name} />
                }
                redirectToLink={redirectToLink}
                pushDataToGTM={pushDataToGTM}
              />
            }
            overlayClassName={`l1-${
              disabled ? 'disabled' : 'enabled'
            }-popover-container`}
          >
            <SubModuleSingleItem
              itemSelected={itemSelected}
              itemHovered={itemHovered}
              {...subModule}
              dispatchAction={dispatchAction}
              handleRedirectionAndModuleSelection={
                handleRedirectionAndModuleSelection
              }
              l1_itemHovered={l1_itemHovered}
            />
          </CapPopover>
        ) : (
          <SubModuleSingleItem
            itemSelected={itemSelected}
            itemHovered={itemHovered}
            {...subModule}
            dispatchAction={dispatchAction}
            handleRedirectionAndModuleSelection={
              handleRedirectionAndModuleSelection
            }
            l1_itemHovered={l1_itemHovered}
          />
        ))}
      {type === 'collapsible' && (
        <CollapsibleItemsWrapper
          {...subModule}
          itemHovered={itemHovered}
          handleRedirectionAndModuleSelection={
            handleRedirectionAndModuleSelection
          }
          l1_itemHovered={l1_itemHovered}
          dispatchAction={dispatchAction}
          currentState={currentState}
          pushDataToGTM={pushDataToGTM}
          redirectToLink={redirectToLink}
        />
      )}
      {type === 'sectionHead' && (
        <>
          <Divider />
          {!!nextSectionName ? <CapHeading type="h6" className="l2-section-head">
            <FormattedMessageWrapper
              id={nextSectionDisplayLabel}
              message={nextSectionName}
            />
          </CapHeading>:<CapRow style={{marginTop:'0.857rem'}} data-testid="nextSextion-row"></CapRow>}
        </>
      )}
      {type === 'quickLink' &&
        (disabled && validateDisabledConfig(disabledConfig) ? (
          <CapPopover
            placement="right"
            content={
              <DisabledHoverPopover
                {...disabledConfig}
                title={
                  <FormattedMessageWrapper id={displayLabel} message={name} />
                }
                redirectToLink={redirectToLink}
                pushDataToGTM={pushDataToGTM}
              />
            }
            overlayClassName={`l1-${
              disabled ? 'disabled' : 'enabled'
            }-popover-container`}
          >
            <QuickLinkSingleItem
              {...subModule}
              itemSelected={itemSelected}
              itemHovered={itemHovered}
              dispatchAction={dispatchAction}
              handleRedirectionAndModuleSelection={
                handleRedirectionAndModuleSelection
              }
              l1_itemHovered={l1_itemHovered}
            />
          </CapPopover>
        ) : (
          <QuickLinkSingleItem
            {...subModule}
            itemSelected={itemSelected}
            itemHovered={itemHovered}
            dispatchAction={dispatchAction}
            handleRedirectionAndModuleSelection={
              handleRedirectionAndModuleSelection
            }
            l1_itemHovered={l1_itemHovered}
          />
        ))}
    </>
  );
};

L2Module.defaultProps = {
  currentState: {},
  subModule: {},
  index: 0,
  dispatchAction: () => {},
  handleRedirectionAndModuleSelection: () => {},
  redirectToLink: () => {},
  pushDataToGTM: () => {},
};

export default L2Module;
